import React, { useEffect, useState } from "react";
import style from "../Assets/css/mycourse.module.css";
import toggleUp from "../Assets/img/profile/toggle_up.png";
import toggleDown from "../Assets/img/profile/toggle_down.png";
import courseimg from "../Assets/img/coursimg.jpg";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Notifications from "../components/Notifications";
import styles from "../Assets/css/signup.module.css";
import MyCourseCarousel from "./MyCourseCarousel";

import {
	Link,
	NavLink,
	Route,
	Switch,
	useLocation,
	useParams,
} from "react-router-dom";
import Course from "../components/course";
import Rectangle from "../Assets/img/Rectangle.png";
import References from "./References";
import Progress from "react-circle-progress-bar";
import VideoPlayer from "react-video-js-player";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
// import Typed from 'typed.js';
import { BASE_URL } from "../env";
function MyCourseContentPanel(props) {
	// console.log(props);
	return <div>{props.children}</div>;
}

function UpcomingClasses() {
	return (
		<div className="d-flex justify-content-center">
			<div
				class={`col-xl-6 col-lg-6 col-md-6 col-sm-6 ${style.upcoming_classes_div}`}
			>
				<div class={style.upcoming_classes}>
					<h5 class={style.upcoming}>Upcoming Classes</h5>
					<div class={`d-flex ${style.class_schedule_div}`}>
						<div>
							<img
								src="./images/Vector1.png"
								alt=""
								class={style.class_date_icon}
							/>
							27th June
						</div>
						<div>
							<img
								src="./images/Group 119.png"
								alt=""
								class={style.class_time_icon}
							/>
							8AM - 10AM
						</div>
						<div>
							<button type="submit" class={style.join_sm_btn}>
								JOIN
							</button>
						</div>
					</div>

					<h6 class={style.intro_topic}>Introduction to merging</h6>
					<div class={`d-flex ${style.class_schedule_div1}`}>
						<div>
							<img
								src="./images/Vector1.png"
								alt=""
								class={style.class_date_icon}
							/>
							27th June
						</div>
						<div>
							<img
								src="./images/Group 119.png"
								alt=""
								class={style.class_time_icon}
							/>
							8AM - 10AM
						</div>
						<div>
							<button type="submit" class={style.join_sm1_btn}>
								JOIN
							</button>
						</div>
					</div>

					<h6 class={style.intro_topic}>
						Introduction Binary Search
					</h6>
					<div class={`d-flex ${style.class_schedule_div1}`}>
						<div>
							<img
								src="./images/Vector1.png"
								alt=""
								class={style.class_date_icon}
							/>
							27th June
						</div>
						<div>
							<img
								src="./images/Group 119.png"
								alt=""
								class={style.class_time_icon}
							/>
							8AM - 10AM
						</div>
						<div>
							<button type="submit" class={style.join_sm1_btn}>
								JOIN
							</button>
						</div>
					</div>

					<h6 class={style.intro_topic}>Introduction to sorting</h6>
					<div class={`d-flex ${style.class_schedule_div1}`}>
						<div>
							<img
								src="./images/Vector1.png"
								alt=""
								class={style.class_date_icon}
							/>
							27th June
						</div>
						<div>
							<img
								src="./images/Group 119.png"
								alt=""
								class={style.class_time_icon}
							/>
							8AM - 10AM
						</div>
						<div>
							<button type="submit" class={style.join_sm1_btn}>
								JOIN
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

function MyCourseContentTabs(props) {
	// console.log(props);
	const [selected, setSelected] = useState(props.selected || null);

	function handleChange() {
		setSelected(null);
	}
	return (
		<div>
			{props.children.map((elem, index) => {
				let style1 = index === selected ? "selected" : "";
				return (
					<div className={style.topics}>
						{index == selected ? (
							<div
								style={{ objectFit: "contain" }}
								onClick={() => {
									setSelected(null);
								}}
								className={`d-flex ${style.topic_name_div}`}
							>
								<div>
									<h5 className={style.topic_name}>
										{elem.props.title}
									</h5>
									<progress
										id="file"
										max="100"
										value={elem.props.progressBarValue}
									>
										{" "}
										70%{" "}
									</progress>
								</div>
								<img
									style={{ width: "10%", height: "10%" }}
									src={toggleDown}
									alt=""
								/>
							</div>
						) : (
							<div
								style={{ objectFit: "contain" }}
								onClick={() => setSelected(index)}
								className={`d-flex ${style.topic_name_div}`}
							>
								<div>
									<h5 className={style.topic_name}>
										{elem.props.title}
									</h5>
									<progress
										id="file"
										max="100"
										value={elem.props.progressBarValue}
									>
										{" "}
										70%{" "}
									</progress>
								</div>
								<img
									style={{ width: "10%", height: "10%" }}
									src={toggleUp}
									alt=""
								/>
							</div>
						)}
						{index == selected && (
							<div>{props.children[selected]}</div>
						)}
					</div>
				);
			})}
		</div>
	);
}

const MyCourse = (props) => {
	const params = useParams();

	const location = useLocation();
	const ID = location.pathname.substring(10, 34);

	const [courseid, setCourseid] = useState("");
	const [videoRef, setVideoRef] = useState([]);
	var courseID = "";
	// const [selectedcourse,setSelectedcourse] = useState([])
	var SelectedCourse = [];
	const [progress, setProgress] = useState([]);
	const [TotalVideos, setTotalVideos] = useState([]);
	const [percentage, setPercentage] = useState(0);
	useEffect(() => {
		if (props.location.aboutProps !== undefined) {
			setCourseid(props.location.aboutProps.name);
		}

		fetch(BASE_URL + "/getProfile", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				// console.log(data.student.smallCourses.filter((value,index)=>{
				//   // console.log(value.courseId + " " + ID)
				//   return value.courseId == ID
				// }))

				SelectedCourse = data.student.smallCourses.filter(
					(value, index) => {
						// console.log(value.courseId + " " + ID)
						return value.courseId == ID;
					}
				);
				// setSelectedcourse(data.student.smallCourses.filter((value,index)=>{
				//   // console.log(value.courseId + " " + ID)
				//   return value.courseId == ID
				// }))
				// setCourses(data.student.smallCourses);
				console.log(SelectedCourse[0]);
				setProgress(SelectedCourse[0].progress);
				setTotalVideos(SelectedCourse[0].totalVideos);
			});
		// console.log(params);
	}, []);

	useEffect(() => {
		setPercentage((progress.length / TotalVideos) * 100);
	}, [TotalVideos]);

	useEffect(() => {
		// console.log(location.pathname.substring(10, 34));
	}, [location]);

	const [description, setDescription] = useState("");
	const [whatyouget, setWhatyouget] = useState("");
	// console.log(params);

	useEffect(() => {
		// console.log(courseid)
		fetch(BASE_URL + "/getCourse/" + ID, {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((dta) => {
				console.log(dta);
				setdata(dta);
				console.log(dta.data[0]);
				setWhatyouget(dta.data[0].learning);
				setDescription(dta.data[0].description);
				setSection(dta.data[0].videos);
				setVideoRef(dta.data[0].generalVideos);
				setVideos(dta.data[0].videos);
				setcourseName(dta.data[0].name);
			});
	}, [courseid]);

	useEffect(() => {
		console.log(videoRef);
	}, [videoRef]);
	// console.log(courseid)
	let checkbox = {
		"Searching and Sorting": {
			"Linear Search": true,
			"Binary Search": true,
			"Bubble Sort": false,
			"Selection Sort": false,
			"Insertion Sort": true,
			"Count Sort": false,
			"Merge Sort": false,
			"Quick Sort": false,
		},
	};
	const [sections, setSections] = useState([]);
	const [videos, setVideos] = useState([]);

	let [test, setTest] = useState({
		"Searching and Sorting": {
			"Linear Search": true,
			"Binary Search": true,
			"Bubble Sort": false,
			"Selection Sort": false,
			"Insertion Sort": true,
			"Count Sort": false,
			"Merge Sort": false,
			"Quick Sort": false,
		},
	});

	const [Data, setdata] = useState("");
	const [courseName, setcourseName] = useState("");
	useEffect(() => {
		fetch(BASE_URL + "/smallCourses/getAllcourses", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				// setdata(data)
				// console.log(data.data[0]);
				// setSection(data.data[0].videos)
				// setVideos(data.data[0].videos)
			});
	}, []);

	function onlyUnique(value, index, self) {
		return self.indexOf(value) === index;
	}
	function setSection(data) {
		const sections = data.map((value, index) => value.section);
		var uniqueSection = sections.filter(onlyUnique);
		console.log(data);
		console.log(uniqueSection);
		setSections(uniqueSection);
	}

	const [coursecontents, setCourseContents] = useState(true);
	const [upcomingClass, setUpcoming] = useState(false);
	let [LinearSearch, setLinearSearch] = useState(true);
	let [BinarySearch, setBinarySearch] = useState(true);
	let [BubbleSort, setBubbleSort] = useState(true);
	let [InsertionSort, setInsertionSort] = useState(true);
	let [SelectionSort, setSelectionSort] = useState(false);
	let [MergeSort, setMergeSort] = useState(false);
	let [CountSort, setCountSort] = useState(false);
	let [QuickSort, setQuickSort] = useState(false);

	let [count, setCount] = useState(4);
	let [pro, setPro] = useState(
		(Object.keys(checkbox["Searching and Sorting"]).filter(
			(s) => checkbox["Searching and Sorting"][s]
		).length *
			100) /
			8
	);

	// setCount(
	//   Object.keys(checkbox["Searching and Sorting"]).filter(
	//     (s) => checkbox["Searching and Sorting"][s]
	//   )
	// );

	function OverViewData() {
		return (
			<>
				<h2>
					<strong>TCS Ninja</strong>
				</h2>
				<br />
				<p>
					TCS conducts the National Qualifier Test every year to hire
					two profiles TCS NINJA Vs TCS DIGITAL. Out of the two, it is
					the NINJA profile that garners more recruits every year. TCS
					NINJA profile offers you a package of 3.6-3.8LPA and it is
					the profile for which most of the mass is hired. If you
					qualify for NINJA you will be offered the role of Assistant
					Systems Engineer. The reason being the difficulty level of
					the various hiring rounds and the cutoff criteria. Based on
					the performance during online training on the Xplore portal
					and then Academic Training by TCS itself, candidates are
					mapped to various units such as Business Unit, IT, and so
					on. Roles and responsibilities of an Associate Systems
					Engineer i.e NINJA profile holder. They are mapped to a
					technology domain based on their performance in the TCS
					Xplore program and Academic training by TCS. Any Ninja
					candidate is assigned a project based on his/her CPA (Camera
					Proctored Assessment). A Ninja is given a software project
					based on React, .Net, Java, and so on. Or, the Business Unit
					roles such as operations, maintenance, testing, or supply
					chain.
				</p>
				<br />
				<h2>
					<strong>TCS DIGITAL</strong>
				</h2>
				<br />
				The most hyped profile of TCS’s Recruitment process is TCS
				DIGITAL. Through the DIGITAL profile, TCS aims to recruit
				freshers for the post of System Engineer, and the compensation
				offered for this role is 7 LPA. But you should just not be wooed
				by the salary, as the role requires a candidate to be
				technically sound. Through its DIGITAL profile, TCS aims to hire
				some extraordinary minds who know the nuances of the latest
				technologies like Machine Learning, IoT, Data Science,
				Blockchain, etc. The candidates should have good coding skills
				and should be well versed with the concepts like Data Structures
				& Algorithms, Networking, Operating Systems, and most
				importantly Competitive Programming. Roles and responsibilities
				for the TCS DIGITAL profile: They are mapped to a unit based on
				their performance in the TCS Xplore program and their
				awareness.Any Digital candidate is assigned a project based on
				his/her CPA (Camera Proctored Assessment).A Digital is given a
				software project based on Machine Learning, the Internet of
				Things, and so on.Or, the Data Unit roles such as analyst or
				scientist.
				<br />
				There are three opportunities in which you can apply for a TCS
				DIGITAL profile.
				<br />
				<br />
				<br /> <strong> - CODEVITA</strong>
				<br />
				<br />
				<strong> - National Qualifier Test (NQT)</strong>
				<br />
				<br />
				<strong>
					{" "}
					- Upgradation to TCS DIGITAL (after onboarding)
				</strong>
				<br />
				<br />
				<br />
				<h2>
					<strong>Course Features</strong>
				</h2>
				This course is structured according to the TCS exam syllabus to
				help you best prepare for it.
				<br />
				<br />
				<strong> - Expert Mentors</strong>
				<br />
				<br />
				<strong>- Premium Quality Courses</strong>
				<br />
				<br />
				<strong>- Doubt Support Mock Interviews Certificates</strong>
				<br />
				<br />
				<strong> - Hands-on Projects and Assignments</strong>
				<br />
				<br />
				<strong> - Curriculum Faculty</strong>
				<br />
				<br />
				<h2>
					<strong>Course Outcome</strong>
				</h2>
				<p>
					This course is uniquely designed and you will encounter all
					the Previous Year Questions, the tips for Interview
					Preparation, and many more benefits.
				</p>
			</>
		);
	}
	function CourseOverview({ description, whatyouget }) {
		return (
			<>
				<div className="container ">
					<div className="row shadow border ">
						<h5 className="py-4 px-2 bg-primary text-light rounded">
							Description
						</h5>

						<div className="row">
							<>
								<div className="col-sm-10 p-0">
									<ol>
										<li
											style={{
												fontSize: "1.0rem",
												fontFamily: "DM Sans",
											}}
										>
											<OverViewData />
										</li>
										<br />
									</ol>
								</div>
							</>

							{/* <li style={{fontSize:"1.3rem",fontFamily:"DM Sans",fontWeight:"600"}} >&#10003; How to learn C++</li> <br />
                <li style={{fontSize:"1.3rem",fontFamily:"DM Sans",fontWeight:"600"}}>&#10003; How to learn C++</li> <br />
                <li style={{fontSize:"1.3rem",fontFamily:"DM Sans",fontWeight:"600"}}>&#10003; How to learn C++</li> <br />
                <li style={{fontSize:"1.3rem",fontFamily:"DM Sans",fontWeight:"600"}}>&#10003; How to learn C++</li> <br /> */}

							{/* <div className="col-sm-6 p-0">
            <ol className="p-1">
                <li style={{fontSize:"1.3rem",fontFamily:"DM Sans",fontWeight:"600"}}>&#10003; How to learn C++</li> <br />
                <li style={{fontSize:"1.3rem",fontFamily:"DM Sans",fontWeight:"600"}}>&#10003; How to learn C++</li> <br />
                <li style={{fontSize:"1.3rem",fontFamily:"DM Sans",fontWeight:"600"}}>&#10003; How to learn C++</li> <br />
                <li style={{fontSize:"1.3rem",fontFamily:"DM Sans",fontWeight:"600"}}>&#10003; How to learn C++</li> <br />
              </ol>
            </div> */}
						</div>
					</div>
					{/* <div className="row my-5">
            <h5 className="py-4 m-0 bg-primary text-light">
              What is TCS NQT (DIGITAL + NINJA) ?
            </h5>
            <div className="shadow-sm border description pl-2 py-5">
              {description}
            </div>
          </div>
          <div className="row">
            <h4>Course </h4>
            <ol>
              <li>
                <p>Nothing</p>
              </li>
              <br />
              <li>Nothing</li>
              <br />
              <li>Nothing</li>
              <br />
              <li>Nothing</li>
              <br />
              <li>Nothing</li>
              <br />
            </ol>
          </div> */}
				</div>
			</>
		);
	}

	useEffect(() => {
		console.log(count);
	}, [count]);

	function checkHandle(value) {
		console.log(value);
		switch (value) {
			case true:
				setCount(count + 1);
				break;
			case false:
				setCount(count - 1);
				break;
			default:
				return "NOTHING";
		}
	}
	console.log(pro);
	function test1() {
		console.log(test);
	}

	function test2() {
		// setState(test)
		setTest((test["Searching and Sorting"]["Linear Search"] = false));
	}

	function CardMovie(props) {
		const { id, name, link, number, courseID } = props;
		return (
			<>
				<div class="card shadow mx-2  card-body ">
					{/* <img class="card-img" src={link} alt="Card image cap" /> */}
					<a hre={link}>
						<h3
							class="card-text "
							style={{
								textAlign: "center",
								color: "#185ADB",
								fontWeight: "600",
							}}
						>
							{name}
						</h3>
					</a>
					<p
						class="card-text"
						style={{
							textAlign: "center",
							color: "#185ADB",
							fontWeight: "600",
						}}
					>
						Some quick example text to build on the card title and
						make up the bulk of the card's content.{name}
					</p>
				</div>
			</>
		);
	}

	function Technical_section() {
		return (
			<>
				<div className="row my-4">
					<div className="col-lg-2 col-md-2 col-sm-6 mx-auto">
						<div class="card shadow mx-2 card-body my-4">
							{/* <img class="card-img" src={link} alt="Card image cap" /> */}
							<a href="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/TECHNICAL+PDFS/ARRAY.pdf">
								<p
									class="card-text "
									style={{
										textAlign: "center",
										color: "#185ADB",
										fontWeight: "600",
									}}
								>
									Arrays
								</p>
							</a>
						</div>
					</div>
					<div className="col-lg-2 col-md-2 col-sm-6 mx-auto">
						<div class="card shadow mx-2 card-body my-4">
							{/* <img class="card-img" src={link} alt="Card image cap" /> */}
							<a href="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/TECHNICAL+PDFS/QUEUES.pdf">
								<p
									class="card-text "
									style={{
										textAlign: "center",
										color: "#185ADB",
										fontWeight: "600",
									}}
								>
									Queue
								</p>
							</a>
						</div>
					</div>
					<div className="col-lg-2 col-md-2 col-sm-6 mx-auto">
						<div class="card shadow mx-2 card-body my-4">
							<a href="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/TECHNICAL+PDFS/STACKS.pdf">
								<p
									class="card-text "
									style={{
										textAlign: "center",
										color: "#185ADB",
										fontWeight: "600",
									}}
								>
									Stacks
								</p>
							</a>
						</div>
					</div>
					<div className="col-lg-2 col-md-2 col-sm-6 mx-auto">
						<div class="card shadow mx-2 card-body my-4">
							<a href="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/TECHNICAL+PDFS/STRINGS.pdf">
								<p
									class="card-text "
									style={{
										textAlign: "center",
										color: "#185ADB",
										fontWeight: "600",
									}}
								>
									Strings
								</p>
							</a>
						</div>
					</div>
					<div className="col-lg-2 col-md-2 col-sm-6 mx-auto">
						<div class="card shadow mx-2 card-body my-4">
							{/* <img class="card-img" src={link} alt="Card image cap" /> */}
							<a href="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/TECHNICAL+PDFS/Top+50-Difficult++DSA+Problem+Statements.pdf">
								<p
									class="card-text "
									style={{
										textAlign: "center",
										color: "#185ADB",
										fontWeight: "600",
									}}
								>
									Top 50 DSA Problems
								</p>
							</a>
						</div>
					</div>
				</div>
			</>
		);
	}

	function Aptitute() {
		return (
			<>
				<div className="row my-4">
					<div className="col-lg-2 col-md-2 col-sm-6 mx-auto">
						<div class="card shadow mx-2 card-body my-4">
							{/* <img class="card-img" src={link} alt="Card image cap" /> */}
							<a href="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Interview+Kit/Getting+into+mindset+of+a+recruiter_CantileverLabs_(Toolkit+7).pdf">
								<p
									class="card-text "
									style={{
										textAlign: "center",
										color: "#185ADB",
										fontWeight: "600",
									}}
								>
									Topic 1
								</p>
							</a>
						</div>
					</div>
					<div className="col-lg-2 col-md-2 col-sm-6 mx-auto">
						<div class="card shadow mx-2 card-body my-4">
							{/* <img class="card-img" src={link} alt="Card image cap" /> */}
							<a href="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Interview+Kit/Resume+Ingredients.pdf">
								<p
									class="card-text "
									style={{
										textAlign: "center",
										color: "#185ADB",
										fontWeight: "600",
									}}
								>
									Topic 2
								</p>
							</a>
						</div>
					</div>
					<div className="col-lg-2 col-md-2 col-sm-6 mx-auto">
						<div class="card shadow mx-2 card-body my-4">
							<a href="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Interview+Kit/Resume+templates+that+will+get+you+shortlisted_Cantilever+Labs_(Toolkit+3)+(1).pdf">
								<p
									class="card-text "
									style={{
										textAlign: "center",
										color: "#185ADB",
										fontWeight: "600",
									}}
								>
									Topic 3
								</p>
							</a>
						</div>
					</div>
				</div>
			</>
		);
	}

	function InterviewKit() {
		return (
			<>
				<div className="row my-4">
					<div className="col-lg-2 col-md-2 col-sm-6 mx-auto">
						<div class="card shadow mx-2 card-body my-4">
							{/* <img class="card-img" src={link} alt="Card image cap" /> */}
							<a href="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Interview+Kit/Getting+into+mindset+of+a+recruiter_CantileverLabs_(Toolkit+7).pdf">
								<p
									class="card-text "
									style={{
										textAlign: "center",
										color: "#185ADB",
										fontWeight: "600",
									}}
								>
									Topic 1
								</p>
							</a>
						</div>
					</div>
					<div className="col-lg-2 col-md-2 col-sm-6 mx-auto">
						<div class="card shadow mx-2 card-body my-4">
							{/* <img class="card-img" src={link} alt="Card image cap" /> */}
							<a href="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Interview+Kit/Resume+Ingredients.pdf">
								<p
									class="card-text "
									style={{
										textAlign: "center",
										color: "#185ADB",
										fontWeight: "600",
									}}
								>
									Topic 2
								</p>
							</a>
						</div>
					</div>
					<div className="col-lg-2 col-md-2 col-sm-6 mx-auto">
						<div class="card shadow mx-2 card-body my-4">
							<a href="https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/Interview+Kit/Resume+templates+that+will+get+you+shortlisted_Cantilever+Labs_(Toolkit+3)+(1).pdf">
								<p
									class="card-text "
									style={{
										textAlign: "center",
										color: "#185ADB",
										fontWeight: "600",
									}}
								>
									Topic 3
								</p>
							</a>
						</div>
					</div>
				</div>
			</>
		);
	}

	function CourseContents(props) {
		// console.log(props)
		const ID = props.courseID;
		const section = props.section;
		const section_1 = [
			"Technical Kit",
			// "Aptitude Kit",
			"Interview Kit",
			"Questions Paper's",
		];
		const pdf_links = [
			"https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/TECHNICAL+PDFS/ARRAY.pdf",

			,
			"https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/TECHNICAL+PDFS/QUEUES.pdf",

			,
			"https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/TECHNICAL+PDFS/STACKS.pdf",

			,
			"https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/TECHNICAL+PDFS/STRINGS.pdf",
			,
			"https://courses-upload-bucket.s3.ap-south-1.amazonaws.com/TECHNICAL+PDFS/Top+50-Difficult++DSA+Problem+Statements.pdf",
		];
		const datas = [
			"Arrays",
			"Queue",
			"Stacks",
			"Strings",
			"Top 50 DSA Problems Questions",
		];
		const videos = props.videos;
		console.log(section);
		console.log(videos);
		return (
			<>
				<div className="row">
					<h5>
						Technical Kit
						<p
							style={{ color: "blue" }}
							className={styles.horizontalhr}
						>
							{/* <span
                      style={{ color: "gray" }}
                      className={styles.horizontal}
                    >
                      {" "}
                      or
                    </span> */}
						</p>
					</h5>
					<Technical_section />
				</div>
				<div className="row">
					<h5>
						Interview Kit
						<p
							style={{ color: "blue" }}
							className={styles.horizontalhr}
						>
							{/* <span
                      style={{ color: "gray" }}
                      className={styles.horizontal}
                    >
                      {" "}
                      or
                    </span> */}
						</p>
					</h5>
					<InterviewKit />
				</div>
				<div className="row">
					<h5>
						Aptitute Kit
						<p
							style={{ color: "blue" }}
							className={styles.horizontalhr}
						>
							{/* <span
                      style={{ color: "gray" }}
                      className={styles.horizontal}
                    >
                      {" "}
                      or
                    </span> */}
						</p>
					</h5>
					<Aptitute />
				</div>

				{/* <div className="row my-3">
        <h5>Introduction Concepts:</h5>
      <div className="col-sm-6 p-0">
        <CardMovie />
        </div>
        <div className="col-sm-6 p-0 ">
      <CardMovie/>
      </div>
      
      </div>
       <div className="row my-3">
        <h5>Medium Concepts:</h5>
      <div className="col-sm-6 p-0">
        <CardMovie />
        </div>
        <div className="col-sm-6 p-0 ">
      <CardMovie/>
      </div>
      
      </div> */}
			</>
		);
	}

	useEffect(() => {
		fetch(BASE_URL + "/getProfile", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				// console.log(data)
			});
	}, []);

	const [coursecontent, setcoursecontent] = useState(true);
	const [reference, setreferences] = useState(false);
	const [courseoverview, setcourseoverview] = useState(false);
	const [onetoone, setonetoone] = useState(false);
	var onetoOne = document.getElementById("onetone");
	var contentcourse = document.getElementById("contentcourse");
	var overviewcourse = document.getElementById("overviewcourse");
	var referencess = document.getElementById("references");
	function onetonetrue() {
		// onetoOne?.classList.add(style.selectedcolor);
		// contentcourse?.classList.remove(style.selectedcolor);
		// overviewcourse?.classList.remove(style.selectedcolor);
		// referencess?.classList.remove(style.selectedcolor);
		setonetoone(true);
		setcoursecontent(false);
		setcourseoverview(false);
		setreferences(false);
	}
	function coursecontenttrue() {
		// contentcourse.classList.add(style.selectedcolor);
		// onetoOne.classList.remove(style.selectedcolor);
		// overviewcourse.classList.remove(style.selectedcolor);
		// referencess.classList.remove(style.selectedcolor);
		setonetoone(false);
		setcoursecontent(true);
		setcourseoverview(false);
		setreferences(false);
	}
	function courseoverviewtrue() {
		// overviewcourse?.classList.add(style.selectedcolor);
		// onetoOne?.classList.remove(style.selectedcolor);
		// contentcourse?.classList.remove(style.selectedcolor);
		// referencess?.classList.remove(style.selectedcolor);
		setonetoone(false);
		setcoursecontent(false);
		setcourseoverview(true);
		setreferences(false);
	}
	function referencestrue() {
		// referencess?.classList.add(style.selectedcolor);
		// onetoOne?.classList.remove(style.selectedcolor);
		// overviewcourse?.classList.remove(style.selectedcolor);
		// contentcourse?.classList.remove(style.selectedcolor);
		setonetoone(false);
		setcoursecontent(false);
		setcourseoverview(false);
		setreferences(true);
	}

	useEffect(() => {
		coursecontenttrue();
	}, []);
	return (
		<>
			<Navbar />

			<div className={style.body}>
				<div class={`container-fluid ${style.dashboard}`}>
					<div class="row">
						{/* <Sidebar /> */}
						<div
							class={`col-xl-12 col-lg-12 col-md-12 col-sm-12 ${style.courses_div}`}
						>
							<h1 class={`${style.courses}`}>
								{courseName}
								<p
									style={{ color: "blue" }}
									className={style.horizontalhr}
								>
									{/* <span
                        style={{ color: "gray" }}
                        className={styles.horizontal}
                      >
                        {" "}
                        or
                      </span> */}
								</p>
							</h1>

							<div>
								<MyCourseCarousel />
								<h4 class={style.cp_title}></h4>
								<br />
								{/* <p class={style.cp_text}> */}

								{/* <div className="my-2 py-4 mx-5  row d-flex justify-content-center "> */}
								{/* <h4 className="p-1"> Your progress </h4> */}
								{/* <Progress progress={80} /> */}

								{/* <div
                    className="col-sm-7 mx-5"
                    style={{ width: 200, height: 200, display: "block" }}
                  >
                    <CircularProgressbar
                      transitionDuration={0.5}
                      value={percentage}
                      text={`${percentage}%`}
                    />
                  </div>
                  <div className="col-sm-5 py-2">
                    <h3 style={{ color: "#3E98C7" }}> Progress Report </h3>
                    <br />
                    <span>Total Videos: {TotalVideos}</span>
                    <br />
                    <br />
                    <span>Completed Videos: {progress.length}</span>
                  </div> */}

								{/* <div className="row"></div> */}
								{/* </div> */}
								{/* </p> */}
								<div class={`d-flex ${style.name_div}`}>
									<div class={style.photo_div}>
										<img
											src="./images/Ellipse 724.png"
											alt=""
											class={`img-fluid ${style.photo_img}`}
										/>
									</div>
								</div>
							</div>

							{/* MINE */}
							<div class="row my-1">
								<div
									className="p-3 row"
									style={{ cursor: "pointer" }}
								>
									<span
										style={{
											cursor: "pointer",
											backgroundColor:
												courseoverview && "#185adb",
											color: courseoverview && "white",
										}}
										id="overviewcourse"
										onClick={courseoverviewtrue}
										className={
											"p-2 col text-center " + style.color
										}
										style={{ fontSize: "1.1rem" }}
									>
										Overview
									</span>
									<span
										style={{
											cursor: "pointer",
											backgroundColor:
												coursecontent && "#185adb",
											color: coursecontent && "white",
										}}
										id="contentcourse"
										onClick={coursecontenttrue}
										className={
											"p-2 col text-center " + style.color
										}
										style={{ fontSize: "1.1rem" }}
									>
										Course Contents
									</span>
									<span
										style={{
											cursor: "pointer",
											backgroundColor:
												reference && "#185adb",
											color: reference && "white",
										}}
										id="references"
										onClick={referencestrue}
										className={
											"p-2 col text-center " + style.color
										}
										style={{ fontSize: "1.1rem" }}
									>
										ToolKit
									</span>
								</div>

								<div
									class={`col-xl-12 col-lg-12 col-md-12 col-sm-12 ${style.topics_covered}`}
								>
									<div>
										{coursecontent == true && (
											<References />
										)}
										{courseoverview == true && (
											<CourseOverview
												whatyouget={whatyouget}
												description={description}
											/>
										)}
										{reference == true && (
											<CourseContents
												courseID={ID}
												section={sections}
												videos={videos}
											/>
										)}

										{/* {coursecontents ==true && <>     <CourseContents/> </>}
                    
                    
             {upcomingClass==true &&      <UpcomingClasses/> */}
									</div>
								</div>
							</div>

							{/* <MyCourseContentTabs>
                    <MyCourseContentPanel
                      title="Searching & Sorting"
                      progressBarValue={(count * 100) / 8}
                    >
                      <input
                        type="checkbox"
                        name="lecture"
                        id="lecture"
                        class={style.lecture}
                        // checked
                        value={LinearSearch}
                        checked={LinearSearch}
onChange={(e) => {
                          setLinearSearch(!LinearSearch);
                          console.log(LinearSearch)
                          checkHandle(!LinearSearch);                        
                        }}
                      />{" "}
                      <span class="completed">Linear Search </span> <br />
                      <input
                        type="checkbox"
                        name="lecture"
                        id="lecture"
                        class={style.lecture}
                        checked={BinarySearch}

                        value={BinarySearch}
onChange={(e) => {
                          setBinarySearch(!BinarySearch);
                          checkHandle(!BinarySearch);

                        }}
                      />{" "}
                      <span class="completed">Binary Search </span>
                      <br />
                      <input
                        type="checkbox"
                        name="lecture"
                        id="lecture"
                        class={style.lecture}
                        checked={BubbleSort}
                        value={BubbleSort}
onChange={(e) => {
                          setBubbleSort(!BubbleSort);
                          checkHandle(!BubbleSort);
                          
                        }}
                      />
                      <span class="completed">Bubble Sort </span> <br />
                      <input
                        type="checkbox"
                        name="lecture"
                        id="lecture"
                        class={style.lecture}
                        checked={SelectionSort}
                        value={SelectionSort}
                        onChange={(e) => {
                          console.log(!SelectionSort)

                          setSelectionSort(!SelectionSort);
                          checkHandle(!SelectionSort);
                        }}
                      />{" "}
                      <span class="completed">Selection Sort</span> <br />
                      <input
                        type="checkbox"
                        name="lecture"
                        id="lecture"
                        class={style.lecture}
                        value={InsertionSort}
                        checked={InsertionSort}                        
                        onChange={(e) => {
                          setInsertionSort(!InsertionSort);
                          console.log(InsertionSort)
                          checkHandle(!InsertionSort);
                          
                        }}
                        // onChange={() => setCount(count--)}
                      />{" "}
                      <span>Insertion Sort </span> <br />
                      <input
                        type="checkbox"
                        name="lecture"
                        id="lecture"
                        checked={CountSort}
                        value={CountSort}
                        class={style.lecture}
                        onChange={(e) => {
                          setCountSort(!CountSort);
                          checkHandle(!CountSort);
                        }}
                      />{" "}
                      <span>Count Sort</span> <br />
                      <input
                        type="checkbox"
                        name="lecture"
                        id="lecture"
                        checked={MergeSort}
                        class={style.lecture}
                        value={MergeSort}
onChange={(e) => {
                          setMergeSort(!MergeSort);
                          console.log(CountSort);
                          checkHandle(!MergeSort);
                          
                        }}
                      />{" "}
                      <span>Merge Sort </span> <br />
                      <input
                        type="checkbox"
                        name="lecture"
                        id="lecture"
                        class={style.lecture}
                        checked={QuickSort}
                        value={QuickSort}
onChange={(e) => {
                          setQuickSort(!QuickSort);
                          checkHandle(!QuickSort);
                          
                        }}
                      />{" "}
                      <span>Quick Sort </span> <br />
                    </MyCourseContentPanel>
                    <MyCourseContentPanel title="Basics" progressBarValue="70">
                      {/* <div>H</div>
                    <div>H</div>
                    <div>H</div>
                    <div>H</div> */}
							{/* </MyCourseContentPanel> */}
							{/* <MyCourseContentPanel title="STL" progressBarValue="45">
                      <div>H</div>
                      <div>H</div>
                      <div>H</div>
                      <div>H</div>
                    </MyCourseContentPanel>
                    <MyCourseContentPanel title="DSA" progressBarValue="5">
                      <div>H</div>
                      <div>H</div>
                      <div>H</div>
                      <div>H</div>
                    </MyCourseContentPanel>
                  </MyCourseContentTabs> */}
							{/* Original */}
							{/*  
            <div class="row">
              <div
                class={`col-xl-6 col-lg-6 col-md-6 col-sm-6 ${style.topics_covered}`}
              >
                <div class={style.topics}>
                  <div class={`d-flex ${style.topic_name_div}`}>
                    <div>
                      <h5 class={style.topic_name}>Searching & Sorting</h5>
                    </div>
                    <div>
                      <img src="./images/Group.png" alt="" />
                    </div>
                  </div>
                  <input
                    type="checkbox"
                    name="lecture"
                    id="lecture"
                    class={style.lecture}
                    checked
                  />{" "}
                  <span class="completed">Linear Search </span> <br />
                  <input
                    type="checkbox"
                    name="lecture"
                    id="lecture"
                    class={style.lecture}
                    checked
                  />{" "}
                  <span class="completed">Binary Search </span>
                  <br />
                  <input
                    type="checkbox"
                    name="lecture"
                    id="lecture"
                    class={style.lecture}
                    checked
                  />{" "}
                  <span class="completed">Bubble Sort </span> <br />
                  <input
                    type="checkbox"
                    name="lecture"
                    id="lecture"
                    class={style.lecture}
                    checked
                  />{" "}
                  <span class="completed">Selection Sort</span> <br />
                  <input
                    type="checkbox"
                    name="lecture"
                    id="lecture"
                    class={style.lecture}
                  />{" "}
                  <span>Insertion Sort </span> <br />
                  <input
                    type="checkbox"
                    name="lecture"
                    id="lecture"
                    class={style.lecture}
                  />{" "}
                  <span>Count Sort</span> <br />
                  <input
                    type="checkbox"
                    name="lecture"
                    id="lecture"
                    class={style.lecture}
                  />{" "}
                  <span>Merge Sort </span> <br />
                  <input
                    type="checkbox"
                    name="lecture"
                    id="lecture"
                    class={style.lecture}
                  />{" "}
                  <span>Quick Sort </span> <br />
                </div>
                <div class={style.topics}>
                  <div class={`d-flex ${style.topic_name_div}`}>
                    <div>
                      <h5 class={style.topic_name}>Basics</h5>
                    </div>
                    <div>
                      <img src="./images/Group (1).png" alt="" />
                    </div>
                  </div>
                </div>
                <div class={style.topics}>
                  <div class={`d-flex ${style.topic_name_div}`}>
                    <div>
                      <h5 class={style.topic_name}>STL</h5>
                    </div>
                    <div>
                      <img src="./images/Group (1).png" alt="" />
                    </div>
                  </div>
                </div>
                <div class={style.topics}>
                  <div class={`d-flex ${style.topic_name_div}`}>
                    <div>
                      <h5 class={style.topic_name}>DSA</h5>
                    </div>
                    <div>
                      <img src="./images/Group (1).png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class={`col-xl-6 col-lg-6 col-md-6 col-sm-6 ${style.upcoming_classes_div}`}
              >
                <div class={style.upcoming_classes}>
                  <h5 class={style.upcoming}>Upcoming Classes</h5>
                  <div class={`d-flex ${style.class_schedule_div}`}>
                    <div>
                      <img
                        src="./images/Vector1.png"
                        alt=""
                        class={style.class_date_icon}
                      />
                      27th June
                    </div>
                    <div>
                      <img
                        src="./images/Group 119.png"
                        alt=""
                        class={style.class_time_icon}
                      />
                      8AM - 10AM
                    </div>
                    <div>
                      <button type="submit" class={style.join_sm_btn}>
                        JOIN
                      </button>
                    </div>
                  </div>

                  <h6 class={style.intro_topic}>Introduction to merging</h6>
                  <div class={`d-flex {style.class_schedule_div1}`}>
                    <div>
                      <img
                        src="./images/Vector1.png"
                        alt=""
                        class={style.class_date_icon}
                      />
                      27th June
                    </div>
                    <div>
                      <img
                        src="./images/Group 119.png"
                        alt=""
                        class={style.class_time_icon}
                      />
                      8AM - 10AM
                    </div>
                    <div>
                      <button type="submit" class={style.join_sm1_btn}>
                        JOIN
                      </button>
                    </div>
                  </div>

                  <h6 class={style.intro_topic}>Introduction Binary Search</h6>
                  <div class={`d-flex ${style.class_schedule_div1}`}>
                    <div>
                      <img
                        src="./images/Vector1.png"
                        alt=""
                        class={style.class_date_icon}
                      />
                      27th June
                    </div>
                    <div>
                      <img
                        src="./images/Group 119.png"
                        alt=""
                        class={style.class_time_icon}
                      />
                      8AM - 10AM
                    </div>
                    <div>
                      <button type="submit" class={style.join_sm1_btn}>
                        JOIN
                      </button>
                    </div>
                  </div>

                  <h6 class={style.intro_topic}>Introduction to sorting</h6>
                  <div class={`d-flex ${style.class_schedule_div1}`}>
                    <div>
                      <img
                        src="./images/Vector1.png"
                        alt=""
                        class={style.class_date_icon}
                      />
                      27th June
                    </div>
                    <div>
                      <img
                        src="./images/Group 119.png"
                        alt=""
                        class={style.class_time_icon}
                      />
                      8AM - 10AM
                    </div>
                    <div>
                      <button type="submit" class={style.join_sm1_btn}>
                        JOIN
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>*/}
						</div>
						{/* <Notifications height="55vw" /> */}
						{/* <div
            class={`col-xl-3 col-lg-5 col-md-6 col-sm-6 ${style.notification_div}`}
          >
            <h2 class={style.notifications}>Notifications</h2>
            <h5 class={style.topic}>Introduction to Digital Medium & Tools</h5>
            <p class={style.topic_text}>
              This is an introduction session about how to deal with the latest
              digital tools and understanding the digital relam
            </p>
            <div class={`d-flex ${style.schedule_div}`}>
              <div class={style.date_div}>
                <img
                  src="./images/Vector.png"
                  alt=""
                  class={`img-fluid ${style.calendar_img}`}
                />
                27th June
              </div>
              <div class={style.time_div}>
                <img
                  src="./images/Group 116.png"
                  alt=""
                  class={`img-fluid ${style.clock_img}`}
                />
                8AM-10AM
              </div>
            </div>

            <button type="submit" class={style.join_btn}>
              JOIN
            </button>

            <hr class={style.join_hr} />
            <div class={style.lecture_card_1}>
              <div class="row">
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-2 mx-3 mt-3 col-2">
                  <p>
                    {" "}
                    <b>21st June</b>{" "}
                  </p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-5 col-sm-6 mt-3 col-6">
                  <p>Introduction & Interest Note Class of Coding </p>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mt-3 col-2">
                  <span class="material-icons">cloud_upload</span>
                </div>
              </div>
            </div>

            <div class={style.lecture_card}>
              <div class="row">
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-2 mx-3 mt-3 col-2">
                  <p>
                    {" "}
                    <b> 27th June</b>
                  </p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-5 col-sm-6 mt-3 col-6">
                  <p>Introduction & Interest Note Class of Coding </p>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mt-3 col-2">
                  <span class="material-icons">cloud_done</span>
                </div>
              </div>
            </div>

            <div class={`${style.lecture_card} ${style.text_card}`}>
              <div class="row">
                <div class="col-xl-11 col-lg-11 col-md-11 col-sm-11 mx-3 mt-3 col-11">
                  <p>Please upload all of your coding assignments by tmrw</p>
                  <p class={style.footer_text}>DSA . 27min ago</p>
                </div>
              </div>
            </div>

            <div class={style.lecture_card}>
              <div class="row">
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-2 mx-3 mt-3 col-2">
                  <p>
                    {" "}
                    <b> 27th June</b>
                  </p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-5 col-sm-6 mt-3 col-6">
                  <p>Introduction & Interest Note Class of Coding </p>
                </div>
              </div>
            </div>
          </div> */}
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default MyCourse;
